export const GET_INSIGHTS_VERSION_REQUEST = "GET_INSIGHTS_VERSION_REQUEST";
export const GET_INSIGHTS_VERSION_SUCCESS = "GET_INSIGHTS_VERSION_SUCCESS";
export const GET_INSIGHTS_VERSION_FAILURE = "GET_INSIGHTS_VERSION_FAILURE";
